<template>
    <div>
    <div class="position-relative" >
        <section class="section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 shape-dark shape-skew"/>
            <div class="container shape-container d-flex">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-8">
                            <h1 class="text-white">A <span class="text-white text-cursor">Developer</span> is just around the corner</h1>
                            <p class="lead text-white">I offer anything software-related. The only limitation is your imagination. The opportunity is yours.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <section class="section section-lg pt-lg-0 mt--200 mb-5">
        <div class="container" >
            <div class="row text-center justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-4">
                            <card class="border-0" hover shadow body-classes="py-5">
                                <icon name="ni ni-world-2" size="lg" type="primary" rounded class="mb-3">
                                </icon>
                                <h6 class="text-primary text-uppercase">Website</h6>
                                <p class="description mt-3">I offer custom tailored websites for your needs. Whether if it's for the business or part of a product. There's no limitation.</p>
                                <div>
                                    <badge type="primary" rounded>design</badge>
                                    <badge type="primary" rounded>marketing</badge>
                                    <badge type="primary" rounded>creative</badge>
                                </div>
                            </card>
                        </div>
                        <div class="col-lg-4">
                            <card class="border-0" hover shadow body-classes="py-5">
                                <icon name="fa fa-mobile" size="lg" type="success" rounded class="mb-3">
                                </icon>
                                <h6 class="text-success text-uppercase">Mobile Apps</h6>
                                <p class="description mt-3">I can write apps for IOS & Android to support your business requirements & customers</p>
                                <div>
                                    <badge type="success" rounded>business</badge>
                                    <badge type="success" rounded>product</badge>
                                    <badge type="success" rounded>success</badge>
                                </div>
                            </card>
                        </div>
                        <div class="col-lg-4">
                            <card class="border-0" hover shadow body-classes="py-5">
                                <icon name="ni ni-planet" size="lg" type="warning" rounded class="mb-3">
                                </icon>
                                <h6 class="text-warning text-uppercase">Business Integration</h6>
                                <p class="description mt-3">I offer backend work with extensive experience with various APIs, and API development</p>
                                <div>
                                    <badge type="warning" rounded>integration</badge>
                                    <badge type="warning" rounded>automation</badge>
                                    <badge type="warning" rounded>savings</badge>
                                </div>
                            </card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
</template>

<script>
export default {
    
}
</script>